/**
 * Do not edit directly
 * Generated on Fri, 26 Jan 2024 09:10:52 GMT
 */

export const SbColorWhichRed = '#e81c30'
export const SbColorWhite = '#ffffff'
export const SbColorTextWhite = '#ffffff'
export const SbColorInteractiveBlue = '#0050b3'
export const SbColorVisitedPurple = '#7043a8'
export const SbColorPurple100 = '#694092'
export const SbColorPurple50 = '#b49fc8'
export const SbColorPurple20 = '#e1d9e9'
export const SbColorIndigo100 = '#484b9a'
export const SbColorIndigo50 = '#a3a5cc'
export const SbColorIndigo20 = '#dadbeb'
export const SbColorBlue100 = '#35b0e6'
export const SbColorBlue50 = '#9ad7f2'
export const SbColorBlue20 = '#d7effa'
export const SbColorTeal100 = '#00a69c'
export const SbColorTeal50 = '#7fd2cd'
export const SbColorTeal20 = '#ccedeb'
export const SbColorGreen100 = '#4cab3e'
export const SbColorGreen50 = '#a5d59e'
export const SbColorGreen20 = '#dbeed8'
export const SbColorGreenDark = '#0e8a00'
export const SbColorYellow100 = '#fecc27'
export const SbColorYellow50 = '#fee593'
export const SbColorYellow20 = '#fff5d4'
export const SbColorGold100 = '#f6a31c'
export const SbColorGold50 = '#fad18d'
export const SbColorGold20 = '#fdedd2'
export const SbColorPink100 = '#e36178'
export const SbColorPink50 = '#f1b0bb'
export const SbColorPink20 = '#f9dfe4'
export const SbColorLightGrey100 = '#dadbeb'
export const SbColorCharcoal100 = '#424242'
export const SbColorBlack01 = '#f5f5f5'
export const SbColorBlack100 = '#000000'
export const SbColorBlack05 = '#efefef'
export const SbColorBlack10 = '#e5e5e5'
export const SbColorBlack20 = '#cccccc'
export const SbColorBlack41 = '#929292'
export const SbColorBlack50 = '#7f7f7f'
export const SbColorBlack60 = '#676767'
export const SbColorCorrectGreen = '#01892e'
export const SbColorCautionYellow = '#fcc126'
export const SbColorErrorRed = '#d32f2f'
export const SbColorBrandYellow20 = '#fffae1'
export const SbColorBrandGold20 = '#ffe9c2'
export const SbColorBrandPink20 = '#ffd4d0'
export const SbColorBrandPurple20 = '#e9cae9'
export const SbColorBrandBlue20 = '#c0e8f9'
export const SbColorBrandGreen20 = '#d6ead3'
